import { createFileRoute } from '@tanstack/react-router'
import AssignmentDetailPage from '@/pages/assignments/AssignmentDetailPage'

export const Route = createFileRoute('/assignments/$assignmentId')({
  component: AssignmentDetailPage,
})
